import React, { Component } from "react";


import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE       from "../Utils/Strings/Route";

class ErrorBoundary extends Component {
    constructor(){
        super();
        this.state = {
            hasError : false,
            info     : null,
            error    : null,
        }
    }

    componentDidCatch(error, info) {
        this.setState( { hasError: true, info : info, error : error } );
    }

    render() { 
        if(!this.state.hasError)
            return this.props.children;
        else if (this.state.error === "No token saved!")
            PAGESSWITCH.gotoPageWithParams(ROUTE.Root)
        else{
            console.log(this.state.error, this.state.info)
            return <div>Sai che e' successo? { this.state.error + " = " + JSON.stringify(this.state.info) }</div>
        }
            
    }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/Components/component_ErrorHandler.js